import { getFreshAccessToken } from "./authRefreshOrchestrator";
import { getAccessToken } from "./authState";

function buildHeaders(headers, token) {
    const nextHeaders = new Headers(headers || {});
    if (token) {
        nextHeaders.set("Authorization", `Bearer ${token}`);
    } else {
        nextHeaders.delete("Authorization");
    }
    return nextHeaders;
}

function buildInit(init = {}, token) {
    return {
        ...init,
        headers: buildHeaders(init.headers, token),
    };
}

export async function authFetch(input, init = {}, options = {}) {
    const entrypoint = options.entrypoint || "fetch-401";
    const firstResponse = await fetch(input, buildInit(init, getAccessToken()));

    if (firstResponse.status !== 401 || options.retry === false) {
        return firstResponse;
    }

    const nextToken = await getFreshAccessToken({ entrypoint, force: true });
    return fetch(input, buildInit(init, nextToken));
}
